// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';

class Underline {
	constructor(el) {
		// Elements
		this.$el = el;
		this.html = this.$el.html();

		this.linkEndLine();
		this.attachEvents();
	}

	attachEvents() {
		$(window)
			.on('load', () => {
				this.linkEndLine();
			})
			.on('resize', () => {
				this.linkEndLine();
			});
	}

	getWidth(pre_space, str, post_space, append_elem) {
		var pre = pre_space ? '&nbsp;' : '';
		var post = post_space ? '&nbsp;' : '';

		var tmp_div = $(
			'<span style="white-space: nowrap;">' + pre + str + post + '</span>'
		);
		append_elem.append(tmp_div);
		var width = tmp_div.width();
		tmp_div.remove();
		return width;
	}

	linkEndLine() {
		this.$el.html(this.html);

		var width = this.$el.width();
		var text = this.$el[0].innerHTML;
		var words = text.split(' ');
		var line_width = 0;
		var current_line = '';
		var lines = [];
		words.map((word, index) => {
			if (line_width === 0) {
				line_width += this.getWidth(false, word, false, this.$el);
			} else {
				line_width += this.getWidth(true, word, false, this.$el);
			}

			if (line_width / width > 1) {
				lines.push(current_line);

				line_width = this.getWidth(false, word, false, this.$el); // new line
				current_line = '';
			}
			current_line += (current_line !== '' ? ' ' : '') + word;

			if (index === words.length - 1) {
				lines.push(current_line);
			}
		});

		var end_index = lines.length - 1;
		lines[end_index] =
			'<span class="h-underline-last-line">' + lines[end_index] + '</span>';
		this.$el[0].innerHTML = lines.join(' ');
	}
}

export default Underline;

const _init = () => {
	// Elements
	let $el = $('.h-underline, .rte-page .rich-text h1');
	if ($el.length) {
		$el.each(function () {
			if (!$(this).data('init')) {
				new Underline($(this));
				$(this).data('init', true);
			}
		});
	}
};

_init();

Helper.pubsub.subscribe('initHeadingUnderline', function () {
	_init();
});
